import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function About() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <section id="about" data-testid="about-section" className="py-24 px-6 max-w-3xl mx-auto text-center">
      <div>
        <span className="mono-lbl text-xs text-[#a4133c] tracking-[0.2em] uppercase">{t.about.label}</span>
        <h2 className="serif-disp text-4xl md:text-5xl font-light mt-2 mb-6">
          {t.about.meet} <span className="script-accent text-[#c9933b] text-5xl md:text-6xl">Mocha</span>
        </h2>
        <p className="text-neutral-300 text-base md:text-lg font-light leading-relaxed mb-4 max-w-2xl">
          {t.about.para}
        </p>
        <p className="serif-disp italic text-neutral-400 text-lg mb-8">
          {t.about.quote}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto text-left">
          {t.about.facts.map((f) => (
            <div key={f} className="flex items-center gap-3 border border-white/10 rounded-lg px-4 py-3 bg-white/[0.02]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#a4133c] shrink-0" />
              <span className="text-xs uppercase tracking-wider text-neutral-300 font-mono">{f}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
